import React, { useState } from 'react';
import edit from '../../images/editprofile-icon.svg';
import ImageCrop from '../Popup/ImageCrop';
import Upload from '../Common/upload-image/Upload';

const EditProfileHeader = ({ data, CouncilProfile, refetch }) => {
	const [showModal, setShowModal] = useState(false);
	return (
		<div className='edit-council-header'>
			<div className='user-row'>
				<div className='user-photo'>
					{data?.users[0]?.council_profile?.council_profile_photo && (
						<img
							src={data?.users[0]?.council_profile?.council_profile_photo}
							alt='user'
						/>
					)}
				</div>
				{data?.users[0].council_profile.council_profile_photo ? (
					<div onClick={() => setShowModal(true)} className='edit-photo'>
						<button>
							<img src={edit} alt='edit profile icon' />
						</button>
					</div>
				) : (
					<Upload
						data={data}
						refetch={refetch}
						CouncilProfile={CouncilProfile}
						ImageType='header'
						iconVisible={true}
					/>
				)}
			</div>
			<ImageCrop
				show={showModal}
				onHide={() => setShowModal(false)}
				currentPhoto={data?.users[0].council_profile.council_profile_photo}
				CouncilProfile={CouncilProfile}
				data={data}
				refetch={refetch}
				ImageType='header'
			/>
		</div>
	);
};

export default EditProfileHeader;
